// extracted by mini-css-extract-plugin
export default {"main":"layout_main__JJYvb","noSideBar":"layout_noSideBar__4XJa1","navbar":"layout_navbar__LdxOI"};